import Vue from 'vue'
import VueRouter from 'vue-router'
import MarketHome from '../views/market/MarketHome.vue'
import Stock from '../views/stock/StockWorkspace.vue'
import Contract from '../views/contract/contract.vue'
import Login from '../views/login/Login.vue'
import Logincode from '../views/login/Logincode.vue'
import register from '../views/login/register.vue'
import forgetpwd from '../views/login/forgetpwd.vue'
import account from '../views/account/account.vue'
import consult from '../views/consult/consult.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/lines',
    redirect: '/'
  },
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Base" */ '../layout/Base/Base.vue'),
    children: [
      { path: '', redirect: 'market/cn' },
      { path: 'market/:market', name: 'MarketHome', component: MarketHome }
    ]
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },
  {
    path: '/Logincode',
    name: 'Logincode',
    component: Logincode
  },
  {
    path: '/register',
    name: 'register',
    component: register
  },
  {
    path: '/forgetpwd',
    name: 'forgetpwd',
    component: forgetpwd
  },
  {
    path: '/stocks',
    name: 'stocks',
    component: () => import(/* webpackChunkName: "Base" */ '../layout/Base/Base.vue'),
    children: [
      { path: '', name: '', component: Stock}
    ]
  },
  {
    path: '/account',
    name: 'account',
    component: () => import(/* webpackChunkName: "Base" */ '../layout/Base/Base.vue'),
    children: [
      { path: '', name: '', component: account}
    ]
  },
  {
    path: '/messages',
    component: () => import('../layout/Base/Base.vue'),
    children: [{ path: '', component: () => import('../views/messages/messages.vue') }]
  },
  {
    path: '/about',
    component: () => import('../layout/Base/Base.vue'),
    children: [
      { path: '', component: () => import(/* webpackChunkName: "About" */ '../views/about/About.vue') }
    ]
  },
  {
    path: '/activities',
    component: () => import('../layout/Base/Base.vue'),
    children: [{ path: '', component: () => import('../views/activities/Activities.vue') }]
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import(/* webpackChunkName: "Base" */ '../layout/Base/Base.vue'),
    children: [
      { path: '', component: () => import('../views/settings/settings.vue') }
    ]
  },
  {
    path: '/consult',
    name: 'consult',
    component: () => import(/* webpackChunkName: "Base" */ '../layout/Base/Base.vue'),
    children: [
      { path: '', name: '', component: consult}
    ]
  },
  {
    path: '/contract',
    name: 'contract',
    component: () => import(/* webpackChunkName: "Base" */ '../layout/Base/Base.vue'),
    children: [
      { path: '', name: '', component: Contract}
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
